import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MustMatch } from '@helpers/validations/must-match.validator';
import { ChangePasswordRequest } from '@models/usuario/changePasswordRequest.model';
import { LoginService } from '@services/login/login.service';
import { PasswordStrengthService } from '@services/passwordStrengthService/passwordStrengthService.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { UsuarioService } from '@services/usuario/usuario.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';
import { PasswordStrengthDirective } from '@directives/passwordStrength.directive';

@Component({
  standalone: true,
   imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,  A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule, MatTabsModule, DragDropModule, MatSidenavModule,MatListModule,AuthLayoutComponent,PasswordStrengthDirective],
  selector: 'app-nueva-contrasena',
  templateUrl: 'nueva-contrasena.component.html',
  styleUrl: './nueva-contrasena.component.css',
})
export class NuevaContrasenaComponent {

  titulo: string = '';
    subMenuActive: boolean = false;
    submitted = false;
    parametro: string = '';
    idTipoDocumento: number = 0;
    idEstadoCivil: number = 0;
    idPersona: number = 0;
    valor: any
   // loading: boolean = false;
    errorMessage: string = "";
    hide = true;
    get p() { return this.passwordForm.controls; }
    passwordStrength: any = null;
    passwordForm: FormGroup;
    constructor(
      private formBuilder: FormBuilder,
      private loginService: LoginService,
      private userService: UsuarioService,
      private snackBar: SnackBarService,
      private spinner: NgxSpinnerService,
      private passwordStrengthService: PasswordStrengthService,
    ) {

      this.passwordForm = this.formBuilder.group({
        ClaveNueva: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)])],
        ClaveNuevaRepetir: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(100),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)])],
      }, {
        validator: MustMatch('ClaveNueva', 'ClaveNuevaRepetir')
      });
    }


    ngOnInit(): void {
    }

    changePassword() {
      this.spinner.show()
      let user = this.loginService.getCurrentUser()
      let changePasswordRequest = new ChangePasswordRequest
      changePasswordRequest.userName = user.userName
      changePasswordRequest.oldPassword = btoa(this.passwordForm.controls["ClaveAnterior"].value)
      changePasswordRequest.newPassword = btoa(this.passwordForm.controls["ClaveNuevaRepetir"].value)
      this.userService.changePassword(changePasswordRequest).subscribe(
        data => {
          this.spinner.hide()
          this.snackBar.showSuccess(data.text, "Exito")
        },
        (error) => {
          this.spinner.hide()
          this.snackBar.showError("Ups...  " + error, "Error")
        }
      )
    }

    onPasswordInput() {
      const password = this.passwordForm.controls["ClaveNueva"].value
      this.passwordStrength = this.passwordStrengthService.evaluatePasswordStrength(password);

      // Agregar clase para cambiar el color de la barra de progreso según la seguridad
      if (this.passwordStrength.progress <= 25) {
        this.passwordStrength.class = 'low';
      } else if (this.passwordStrength.progress <= 50) {
        this.passwordStrength.class = 'medium';
      } else {
        this.passwordStrength.class = 'high';
      }
    }
}
